import { Fragment } from 'react';

import {
  EntityResourceLinkExtension,
  FactTableResourceLinkExtension,
} from '@spotify/plugin-confidence-admin';
import {
  ChatResourceLinkExtension,
  ProjectChatResourceLinkExtension,
} from '@spotify/plugin-confidence-chat';
import { IdentityResourceLinkExtension } from '@spotify/plugin-confidence-iam';
import {
  MeasurementResourceLinkExtension,
  MetricResourceLinkExtension,
} from '@spotify/plugin-confidence-metrics';
import { ProjectResourceLinkExtension } from '@spotify/plugin-confidence-projects';
import { PulseResourceLinkExtension } from '@spotify/plugin-confidence-pulse';
import { RecordingResourceLinkExtension } from '@spotify/plugin-confidence-recordings';
import { SurfaceResourceLinkExtension } from '@spotify/plugin-confidence-surfaces';
import { WorkflowInstanceResourceLinkExtension } from '@spotify/plugin-confidence-workflows';

export const defaultResourceLinkExtensionElements = (
  <Fragment>
    <ChatResourceLinkExtension />
    <ProjectChatResourceLinkExtension />
    <IdentityResourceLinkExtension />
    <MetricResourceLinkExtension />
    <MeasurementResourceLinkExtension />
    <EntityResourceLinkExtension />
    <FactTableResourceLinkExtension />
    <ProjectResourceLinkExtension />
    <PulseResourceLinkExtension />
    <RecordingResourceLinkExtension />
    <SurfaceResourceLinkExtension />
    <WorkflowInstanceResourceLinkExtension />
  </Fragment>
);

export const DefaultResourceLinkExtensions = () =>
  defaultResourceLinkExtensionElements;
